import Skeleton from 'react-loading-skeleton';

export type UseDisplayValueProps = {
  width?: number;
};

export default function useDisplayValue(props: UseDisplayValueProps) {
  function fn(value: any, isLoading: boolean): JSX.Element {
    if (isLoading) {
      return <Skeleton count={1} width={props.width || 50} />;
    }
    return value;
  }

  return fn;
}